module.exports = __webpack_public_path__ + "img/img14.28b7e230.png";